// App.tsx
import React from "react";
import { RouterProvider } from "react-router-dom";
// pages
import SnackbarComponent from "./components/Snackbar/Snackbar";
import router from "./route/router";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Cookies from "js-cookie";
import { useAppDispatch } from "./app/hooks";
import { clearAccount } from "./features/accountInfo/accountInfoSlice";

const theme = createTheme({
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            "&:hover": {
              backgroundColor: "#4791db",
            },
          },
        },
      },
    },
  },
});

const App: React.FC = () => {
  const accessToken = Cookies.get("access_token");
  const dispatch = useAppDispatch();
  if (!accessToken) {
    dispatch(clearAccount());
  }
  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
      <SnackbarComponent />
    </ThemeProvider>
  );
};

export default App;
